import React, { useState } from 'react';
import simonPhoto from '../assets/Whoweare/Simon-photo.jpg';
import jenPhoto from '../assets/Whoweare/Jen-photo.jpg';
import jenLogo from '../assets/Whoweare/SIEA_Logo.jpeg';
import '../styles/WhoWeAre.css';
import WhoWeAreTeam from '../components/Home/WhoWeAreTeam';

function WhoWeAre() {
  // Separate states for each agent
  const [isSimonExpanded, setIsSimonExpanded] = useState(false);
  const [isJenExpanded, setIsJenExpanded] = useState(false);

  const toggleSimon = () => {
    setIsSimonExpanded(!isSimonExpanded); // Toggle Simon's bio
  };

  const toggleJen = () => {
    setIsJenExpanded(!isJenExpanded); // Toggle Jen's bio
  };

  return (
    <section className="container text-center" id="who-we-are">
      <h1>Who We Are</h1>
      <WhoWeAreTeam /> {/* team intros */}
      <div className='mt-40 mb-40' id="meet-our-founders">
        <h1>Meet Our Founders</h1>
      </div>

      <div className="agentsContainer">
        {/* Agent 1: Simon */}
        <div className="agentSection" onClick={toggleSimon}>
          <div className="agentHeader">
            <img src={simonPhoto} alt="Simon Yio" className="agentPhoto" />
            <h2>Simon Yio</h2>
            <p className="title">Senior Consultant | Business Owner & Coach <br />
            | Asset Progression Strategist</p>
            <p className="readMore">{isSimonExpanded ? "Read Less" : "Read More"}</p> {/* Toggle text */}
          </div>
          {isSimonExpanded && (
            <div className="agentContent">
              <p className="bio">
              Simon Yio is a prominent figure in Singapore’s real estate industry, renowned for his strategic leadership, deep industry connections, and visionary approach. With over 27 years of experience, Simon has driven growth and innovation at some of the country’s leading real estate firms. His career includes serving as the Chief Operating Officer of one of Singapore’s top four real estate companies, where he led the firm through critical growth phases, and as Managing Director of a local geospatial technology firm, where he spearheaded a public-private partnership with the Ministry of National Development to develop a crisis portal during a challenging period.
              </p>
              <p className='bio'>
              Simon's success is defined by his ability to forge lasting relationships and leverage his vast network to create opportunities. His strong ties with local developers have enabled him to collaborate closely with agent leaders, helping shape and implement effective sales and marketing strategies for residential and commercial projects, and securing key developments in a competitive market.
              </p>
              <p className='bio'>
              Before transitioning to corporate leadership in 2011, Simon was an award-winning agency leader, earning accolades such as the IEA Realtor Awards, PropNex Top Individual Sales and Top Leader Awards, and OrangeTee Top Leader Awards from 2009 to 2010. Consistently ranked among the industry’s top producers, Simon earned the trust and respect of peers and clients.
              </p>
              <p className='bio'>
              Simon’s global investment experience spans a wide array of property types, from private residential and industrial to high-capital market investments. He has advised a property investment firm on capital market properties and guided a PropTech company through public-private partnerships. Simon’s international ventures also include property transactions in Australia and Cambodia.
              </p>
              <p className='bio'>
              With his unparalleled expertise, strong industry connections, and unwavering commitment to excellence, Simon continues to shape the future of real estate, offering invaluable insight and guidance to clients, developers, and businesses alike.
              </p>
            </div>
          )}
        </div>

        {/* Agent 2: Jen */}
        <div className="agentSection" onClick={toggleJen}>
          <div className="agentHeader">
            <img src={jenPhoto} alt="Jen Lee" className="agentPhoto" />
            <h2>Jen Lee</h2>
            <p className="title">Senior Marketing Director | Business Owner <br />
            | Asset Progression Strategist</p>
            <p className="readMore">{isJenExpanded ? "Read Less" : "Read More"}</p> {/* Toggle text */}
          </div>
          {isJenExpanded && (
            <div className="agentContent">
              <p className="bio">
                With a distinguished career built on purposeful strategies and unparalleled dedication, Jen Lee is redefining real estate excellence for families, young professionals, and high-net-worth individuals. As the Marketing Director and owner of a thriving co-living business, Jen seamlessly blends innovation with personalized service, delivering transformative results in Singapore’s competitive property landscape.
              </p>
              <ul className="bioList">
                <li>
                  <strong>Record-Breaking Achievements:</strong>
                  <ul>
                    <li>Sold a resale condominium in January 2024, earning both ERA Superstar Achiever and ERA Top 100 Achievers accolades in February 2024.</li>
                    <li>Achieved record-breaking sales for a 4-room HDB in Ghim Moh (June 2024) and Cambridge Road (November 2024).</li>
                    <li>Set a new benchmark for a privatized HUDC property sale in January 2025.</li>
                  </ul>
                </li>
                <li>
                  <strong>Award-Winning Excellence:</strong>
                  <ul>
                    <li>Founder of Rentable Pte Ltd, a local coliving and property management company</li>
                    <li>Attained record-breaking sales in both HDB and private segments in 2024 and 2025</li>
                    <li>ERA Top 100 Achievers in Feb 2024</li>
                    <li>Ranked Top 20% Achievers in Year 2024</li>
                    <li>Ranked among Top 10% of agents at Group Level in 2024</li>
                    <li>Ranked among Top 5% of agents at Advisory Level in 2024</li>
                    <li>ERA Million Dollar Club member</li>
                    <li>Consistent 5-star Realtor on PropertyGuru</li>
                    <li>Awardee of SIEA's Rookies Award & Salespersons Achievement Award (Platinum) 2025</li>
                  </ul>
                </li>
                <img src={jenLogo} alt="SIEA" className="logoPhoto" />
                <li>
                  <strong>Unmatched Client Trust:</strong>
                  <ul>
                    <li>Consistently earns 5-star ratings for her reliability, dedication, and ability to deliver outstanding outcomes.</li>
                  </ul>
                </li>
              </ul>
              <p className="bio">
                Jen’s modern yet approachable style reflects her belief that real estate is more than just transactions—it’s about building lasting relationships and helping clients achieve milestones that matter. Whether guiding families to their dream homes, advising property investors, or securing the best returns on luxury estates, Jen’s meticulous approach and innovative strategies ensure exceptional results every time.
              </p>
              <p className="bio">
                Explore a new standard of real estate with Jen Lee—where your property aspirations meet purpose, luxury, and excellence.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default WhoWeAre;